export const hasPermission = (user, permission) => {
  const propertyPath = `${process.env.REACT_APP_AUTH0_SCOPE_DOMAIN}/permissions`;
  if (!user[propertyPath]) {
    return false;
  }

  return user[propertyPath].indexOf(permission) !== -1;
};
